import React from 'react'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { CallHomeContainer } from '../components/callHomeContainer'
import {
  ItemsContainer,
  Paragraph,
  StyledPhoneContainer,
} from '../components/SellerNotAvailable/SellerNotAvailable.styles'
import { MainParagraph } from '../components/SellerNotAvailable/MainParagraph'
import { useTranslation } from 'react-i18next'
import { GoToHomeButton } from '../components/SellerNotAvailable/GoToHomeButton'
import { useDevices } from '@gojiraf/responsive'
import { useLocation } from 'react-router-dom'
import { Splash } from '../components/Splash'
import { useStore } from '../hooks/useStore'
import { StoreLogoWithFallback } from '../components/StoreLogoWithFallback'

export function EventNotFound() {
  const { isDesktop } = useDevices()
  const location = useLocation()
  const eventIsFull = location.state?.eventIsFull || false
  const { t } = useTranslation()
  const { postHogTrackEvent } = usePostHogAnalytics()
  const { data: store, isLoading: isLoadingStore } = useStore()

  const getCurrentTitle = () => {
    if (eventIsFull) {
      postHogTrackEvent('message-otm-event-full')
      return <h1>{t('homePage.sellerNotAvailable.eventIsFullTitle')}</h1>
    }
    // if (eventOnGoing) {
    //   return <h1>{t('homePage.sellerNotAvailable.eventStartedTitle')}</h1>
    // }
    postHogTrackEvent('message-otm-event-not-started')
    return <h1>{t('homePage.sellerNotAvailable.eventNotStartedTitle')}</h1>
  }

  const getCurrentParagraph = () => {
    // if (eventOnGoing) return t('homePage.sellerNotAvailable.eventStartedParagraph')
    return t('homePage.sellerNotAvailable.eventNotStartedParagraph')
  }

  const getParagraphText = (baseText) => {
    if (store === undefined) return null
    if (store.storeConfigurations.features.goToHome.subtitle)
      return store.storeConfigurations.features.goToHome.subtitle
    const splitText = baseText.split('Live Shopping')
    return (
      <>
        {splitText.map((textFragment, index) => (
          <React.Fragment key={index}>
            {textFragment}
            {index !== splitText.length - 1 && <strong>Live Shopping</strong>}
          </React.Fragment>
        ))}
      </>
    )
  }

  const renderButtonDynamically = () => {
    if (store === undefined && !store.storeConfigurations.features.goToHome.button.active)
      return null
    // if (eventOnGoing) return <ButtonsBox isOneToManySale />
    return (
      <GoToHomeButton
        url={store.storeConfigurations.features.goToHome.button.url}
        text={store.storeConfigurations.features.goToHome.button.text}
      />
    )
  }

  if (store === null || isLoadingStore) {
    return <Splash />
  }

  return (
    <CallHomeContainer isMobile={!isDesktop} data-test="background-image">
      <StyledPhoneContainer>
        {!!store && (
          <StoreLogoWithFallback
            fallback="/path/to/fallback/image.png"
            src={store.logoUrl}
            alt="Store Logo"
          />
        )}
        <ItemsContainer>
          <MainParagraph>{getCurrentTitle()}</MainParagraph>
          <Paragraph>{getParagraphText(getCurrentParagraph())}</Paragraph>
          {renderButtonDynamically()}
        </ItemsContainer>
      </StyledPhoneContainer>
    </CallHomeContainer>
  )
}
